import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const PictureInPictureIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-labelledby="titleId"
      aria-label="picture in picture icon"
      {...props}
    >
      <path
        d="M19.9139 7.54511C19.9139 4.93754 18.29 3.0957 15.6795 3.0957H8.21387C5.61214 3.0957 3.98047 4.93754 3.98047 7.54511V14.5797C3.98047 17.1873 5.60436 19.0291 8.21387 19.0291"
        stroke={props.fill || "currentColor" || "#202123"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4597 11.418H15.0141C13.4652 11.418 12.4941 12.5145 12.4941 14.0674V18.2551C12.4941 19.8079 13.4603 20.9045 15.0141 20.9045H19.4597C21.0135 20.9045 21.9806 19.8079 21.9806 18.2551V14.0674C21.9806 12.5145 21.0135 11.418 19.4597 11.418Z"
        stroke={props.fill || "currentColor" || "#202123"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PictureInPictureIcon;
